import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

// Catches render-time errors from any descendant component (in practice,
// any lazy-loaded route) and shows a fallback instead of a white screen.
// Suspense already handles the loading path; this handles the failure
// path. Logs to console.error so the stack trace is preserved in dev
// tools and in any browser-side log capture.
export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[RouteErrorBoundary]', error, info?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen bg-[#0F1114] text-[#F0F2F4] flex items-center justify-center px-6">
        <div className="max-w-md w-full bg-[#15181C] border border-white/10 rounded-2xl shadow-xl p-6 space-y-4">
          <div className="flex items-center gap-3">
            <AlertTriangle size={22} className="text-amber-400 shrink-0" />
            <h1 className="text-base font-semibold">Something went wrong</h1>
          </div>
          <p className="text-sm text-[#9ba3b0]">
            The page hit an unexpected error. Reloading usually fixes it.
            If it keeps happening, let us know what you were doing.
          </p>
          <button
            onClick={this.handleReload}
            className="w-full flex items-center justify-center gap-2 text-sm font-semibold bg-emerald-600 hover:bg-emerald-500 text-white px-4 py-2.5 rounded-lg transition"
          >
            <RefreshCw size={14} />
            Reload
          </button>
        </div>
      </div>
    );
  }
}
